"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _Discussion = require("../Discussion");

var _SurveyModal = require("components/SurveyModal");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _Listener = babelHelpers.interopRequireWildcard(require("components/Notifications/Listener"));

var _class, _descriptor, _temp, _class3, _descriptor2, _temp2, _class5, _descriptor3, _temp3, _class7, _descriptor4, _descriptor5, _temp4, _class9, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _class10, _temp5;

var ApplicationHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ApplicationHeader, _Component);

  function ApplicationHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ApplicationHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ApplicationHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ApplicationHeader, [{
    key: "render",
    value: function render() {
      if (this.node.node.applicationInfo) {
        if (this.node.node.applicationInfo.approved) {
          return _react.default.createElement(ApplicationApproved, {
            application: this.node.node
          });
        }

        return _react.default.createElement(ApplicationRejected, {
          application: this.node.node
        });
      }

      return null;
    }
  }]);
  return ApplicationHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var ApplicationApproved = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ApplicationApproved, _Component2);

  function ApplicationApproved() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ApplicationApproved);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ApplicationApproved)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "application", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(ApplicationApproved, [{
    key: "render",
    value: function render() {
      var now = Date.now();
      var exp = new Date(this.application.applicationInfo.expires);
      var expired = exp.getTime() < now;
      return _react.default.createElement("div", {
        className: _classList.default.join('assignment-header application-header accepted', exp.getTime() <= now ? 'expired' : '')
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "check_circle"
      }), _react.default.createElement("div", {
        className: "body"
      }, _react.default.createElement("h1", null, "Application Accepted"), _react.default.createElement("p", null, new Date(this.application.applicationInfo.acceptedAt).format('F j, Y g:i A'), this.application.applicationInfo.acceptedBy ? " by ".concat(this.application.applicationInfo.acceptedBy) : ''), this.application.applicationInfo.discount > 0 && _react.default.createElement("p", null, this.application.applicationInfo.discount, "% off purchase granted"), _react.default.createElement("p", null, expired ? 'Expired' : 'Expires at', " ", exp.format('F j, Y g:i A'))));
    }
  }]);
  return ApplicationApproved;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "application", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var ApplicationRejected = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(ApplicationRejected, _Component3);

  function ApplicationRejected() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, ApplicationRejected);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(ApplicationRejected)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "application", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(ApplicationRejected, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: _classList.default.join('assignment-header application-header declined')
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "check_circle"
      }), _react.default.createElement("div", {
        className: "body"
      }, _react.default.createElement("h1", null, "Application Declined"), _react.default.createElement("p", null, new Date(this.application.applicationInfo.acceptedAt).format('F j, Y g:i A'), this.application.applicationInfo.acceptedBy ? " by ".concat(this.application.applicationInfo.acceptedBy) : '')));
    }
  }]);
  return ApplicationRejected;
}(_react.Component), _temp3), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "application", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
var ApplicationBody = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(ApplicationBody, _Component4);

  function ApplicationBody() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, ApplicationBody);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(ApplicationBody)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "node", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "children", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(ApplicationBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment"
      }, _react.default.createElement("p", null, this.node.account.fullName, " has submitted ", this.node.isScholarship ? ' a scholarship application ' : ' an application ', " for ", this.node.catalogItem.title, "."), _react.default.createElement("p", null, "Submitted:", _react.default.createElement("br", null), new Date(this.node.created).format('F j, Y g:i A')), _react.default.createElement("button", {
        className: "btn btn-primary",
        onClick: this.showSurveyResult
      }, "View ", this.node.isScholarship ? ' Scholarship ' : '', " Application"));
    }
  }, {
    key: "showSurveyResult",
    value: function showSurveyResult() {
      new _SurveyModal.SurveyResultModal(this.node.survey, this.node.account, new Date(this.node.created), this.node).show();
    }
  }]);
  return ApplicationBody;
}(_react.Component), _temp4), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "showSurveyResult", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "showSurveyResult"), _class7.prototype)), _class7);
var ApplicationNode = (_class9 = (_temp5 = _class10 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(ApplicationNode, _Component5);

  function ApplicationNode() {
    var _babelHelpers$getProt5;

    var _this5;

    babelHelpers.classCallCheck(this, ApplicationNode);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(ApplicationNode)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "node", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "commentPosted", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "trackData", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "discussion", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    _this5.state = {
      radioName: "application_".concat(++ApplicationNode._nameIndex),
      expanded: false,
      userProfile: null,
      submitting: false,
      formState: null,
      commentBody: "",
      discount: 0
    };
    return _this5;
  }

  babelHelpers.createClass(ApplicationNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('profileUpdated', this.profileUpdatedEvent);
      (0, _userProfile.getUserProfile)().then(this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdatedEvent);
    }
  }, {
    key: "profileUpdatedEvent",
    value: function profileUpdatedEvent(event) {
      this.profileUpdated(event.profile);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(profile) {
      this.setState({
        userProfile: profile
      });
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      return (0, _fetch.default)('data/discussion/post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          child_type: 'reply',
          parent: this.node.node.id,
          comment: comment,
          trackData: this.trackData
        })
      }).then(function (result) {
        if (result.status == 204) return true;
        if (!result.ok) throw result.json();
        return result.json();
      });
    }
  }, {
    key: "gotCommentText",
    value: function gotCommentText(value) {
      this.setState({
        commentBody: value
      });
    }
  }, {
    key: "canSubmitComment",
    value: function canSubmitComment() {
      if (!this.state.submitting && this.state.formState && !this.hasInvalidDiscount()) {
        return true;
      }

      return false;
    }
  }, {
    key: "hasInvalidDiscount",
    value: function hasInvalidDiscount() {
      return this.state.discount < this.minimumDiscount();
    }
  }, {
    key: "minimumDiscount",
    value: function minimumDiscount() {
      if (this.state.formState == 'applicationAccepted') {
        if (!this.node.node.relatedApplicationInfo || !this.node.node.relatedApplicationInfo.approved || this.node.node.relatedApplicationInfo.discount == 0) {
          if (this.node.node.isScholarship) return 1;
        }
      }

      return 0;
    }
  }, {
    key: "submitComment",
    value: function submitComment(event) {
      var _this6 = this;

      event.preventDefault();

      if (this.canSubmitComment()) {
        this.setState({
          submitting: true
        }, function () {
          var extra = {};

          if (_this6.state.formState == 'applicationAccepted') {
            if (!_this6.node.node.relatedApplicationInfo || !_this6.node.node.relatedApplicationInfo.approved || _this6.node.node.relatedApplicationInfo.discount == 0) {
              var finalPrice = Number(_this6.getFinalPrice());
              var percentOfBase = finalPrice / _this6.node.node.catalogItem.itemPrice;
              var percentOff = 1 - percentOfBase;
              percentOff *= 100;
              extra.discount = Math.round(percentOff);
            }
          }

          (0, _fetch.default)("data/discussion/post", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign({
              child_type: _this6.state.formState,
              parent: _this6.node.node.permissions.replyTo,
              comment: _this6.state.commentBody
            }, extra))
          }).then(function (result) {
            if (result.status == 204) return true;
            if (!result.ok) throw result.json();
            return result.json();
          }).then(function (result) {
            (0, _noty.showNotificationText)("This application has been ".concat(_this6.state.formState == 'applicationAccepted' ? 'accepted' : 'declined', "."));

            _this6.setState({
              submitting: false
            });

            _this6.commentPosted();

            _Listener.default.dispatchEvent(new _Listener.NotificationEvent('updated-applicationSubmitted', {
              data: {
                id: "application:".concat(_this6.node.node.applicationId)
              }
            }));
          }).catch(function (e) {
            (0, _noty.showNotificationText)("An error occurred ".concat(_this6.state.formState == 'applicationAccepted' ? 'accepting' : 'declining', " this application."));

            _this6.setState({
              submitting: false
            });
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.node) {
        return _react.default.createElement("div", {
          className: "comment-thread"
        }, _react.default.createElement(ApplicationHeader, {
          node: this.node
        }), _react.default.createElement(_node.default, {
          node: this.node.node,
          menu: this.node.node.permissions.delete ? [{
            title: 'Delete',
            invoke: this.doDelete
          }] : [],
          discussion: this.discussion,
          oldFooter: _react.default.createElement("footer", null, _react.default.createElement("div", {
            className: "submit"
          }, this.node.node.permissions.reply ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doReply,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "reply"
          }), "\xA0 Reply") : null, this.node.node.permissions.delete ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doDelete,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "delete"
          }), "\xA0 Delete") : null))
        }, _react.default.createElement(ApplicationBody, {
          node: this.node.node
        })), this.node.node.permissions.approve && _react.default.createElement("section", {
          className: "child-comments open"
        }, _react.default.createElement("div", {
          className: "comment-form application-accept-form"
        }, _react.default.createElement("header", null, _react.default.createElement("div", {
          className: "radio"
        }, _react.default.createElement("label", null, _react.default.createElement("input", {
          type: "radio",
          name: this.state.radioName,
          value: "applicationAccepted",
          checked: this.state.formState == 'applicationAccepted',
          onClick: this.setFormState
        }), "Accept application")), _react.default.createElement("div", {
          className: "radio"
        }, _react.default.createElement("label", null, _react.default.createElement("input", {
          type: "radio",
          name: this.state.radioName,
          value: "applicationRejected",
          checked: this.state.formState == 'applicationRejected',
          onClick: this.setFormState
        }), "Decline application"))), this.state.formState && _react.default.createElement("div", {
          className: "form-group"
        }, _react.default.createElement("label", null, "Add a custom message to the application ", this.state.formState == 'applicationAccepted' ? 'accepted' : 'declined', " notification email sent to this user (optional):"), _react.default.createElement(_commentForm.default, {
          bareComment: true,
          placeholder: "",
          updateComment: this.gotCommentText,
          submitting: this.state.submitting,
          userProfile: this.state.userProfile,
          gotCommentField: this.gotCommentField,
          acceptEmptyComment: true
        })), !this.node.node.catalogItem.canApplyDiscount && this.state.formState == 'applicationAccepted' && this.node.node.catalogItem.itemPrice > 0 && _react.default.createElement("div", {
          className: "price-info"
        }, "$0", this.node.node.catalogItem.priceSuffix, " - User's Price"), (!this.node.node.relatedApplicationInfo || !this.node.node.relatedApplicationInfo.approved || this.node.node.relatedApplicationInfo.discount == 0) && this.node.node.catalogItem.canApplyDiscount && this.state.formState == 'applicationAccepted' && _react.default.createElement("div", {
          className: "form-group maybe-with-error"
        }, _react.default.createElement("label", null, "Give this user a discount when they purchase this item:"), _react.default.createElement("div", {
          className: "input-group"
        }, _react.default.createElement("input", {
          type: "text",
          size: "6",
          onChange: this.setDiscount,
          value: this.state.discount,
          className: "form-control"
        }), _react.default.createElement("span", {
          className: "input-group-addon"
        }, "%")), false && this.hasInvalidDiscount() && _react.default.createElement("div", {
          className: "input-error"
        }, "Your discount must be between $", this.minimumDiscount(), "% and 100%.")), this.node.node.catalogItem.canApplyDiscount && this.state.formState == 'applicationAccepted' && _react.default.createElement("div", {
          className: "price-info"
        }, "$", this.getFinalPrice(), this.node.node.catalogItem.priceSuffix, " - User's Price"), this.state.formState && _react.default.createElement("div", {
          className: "submit-form"
        }, _react.default.createElement("button", {
          disabled: !this.canSubmitComment(),
          className: "btn btn-primary",
          onClick: this.submitComment
        }, "Save")))));
      }

      return null;
    }
  }, {
    key: "getFinalPrice",
    value: function getFinalPrice() {
      var userPrice = this.node.node.catalogItem.userPrice;
      var discount = this.state.discount || 0;
      var tgtPrice = Math.max(0, Math.min(userPrice, userPrice * (1 - discount / 100))); // Force percent off to a whole integer.

      var percentOff = Math.round(100 * (tgtPrice / this.node.node.catalogItem.itemPrice));
      tgtPrice = this.node.node.catalogItem.itemPrice * (percentOff / 100);
      return tgtPrice.toFixed(2);
    }
  }, {
    key: "setDiscount",
    value: function setDiscount(_ref) {
      var target = _ref.target;
      if (!isNaN(Number(target.value)) && Number(target.value) >= 0 && Number(target.value) <= 100) this.setState({
        discount: Number(target.value)
      });
    }
  }, {
    key: "setFormState",
    value: function setFormState(_ref2) {
      var target = _ref2.target;
      if (target.checked) this.setState({
        formState: target.value
      });
    }
  }, {
    key: "doDelete",
    value: function doDelete(event) {
      var _this7 = this;

      (0, _fetch.default)('data/discussion/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.node.node.id,
          trackData: this.trackData
        })
      }).then(function () {
        (0, _noty.showNotificationText)('The application has been deleted.');

        _this7.commentPosted();
      });
      if (event) event.preventDefault();
      return false;
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(field) {
      this.commentField = field;
    }
  }, {
    key: "toggleExpando",
    value: function toggleExpando() {
      this.setState(function (st) {
        return {
          expanded: !st.expanded
        };
      });
    }
  }, {
    key: "doReply",
    value: function doReply() {
      var _this8 = this;

      this.setState({
        expanded: true
      }, function () {
        _this8.commentField.focus();
      });
    }
  }]);
  return ApplicationNode;
}(_react.Component), _class10._nameIndex = 0, _temp5), (_descriptor6 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "profileUpdatedEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "profileUpdatedEvent"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "profileUpdated"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "gotCommentText", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "gotCommentText"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "submitComment"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "setDiscount", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "setDiscount"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "setFormState", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "setFormState"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "doDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "doDelete"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "gotCommentField"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "toggleExpando", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "toggleExpando"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "doReply", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "doReply"), _class9.prototype)), _class9);
exports.default = ApplicationNode;